import { ChatAvailabilityResult } from '@varo/graphql-schema-types';
import ChatBanner from 'features/chat/ChatBanner/ChatBanner';
import StatusBanner from 'features/chat/StatusBanner/StatusBanner';
import React from 'react';

/**
 * isLastItem = determine if last element in history array and render the status banner accordingly
 * chatOutageMessage = display chat outage message
 *  isLatestBanner =  add outage message only to the latest default banner
 * chatAvailability = chat availability status
 * unableToConnect = determine if unable to connect to chat
 */

export interface BannerProps {
  isLastItem?: boolean;
  chatOutageMessage?: string;
  isLatestBanner?: boolean;
  chatAvailability?: ChatAvailabilityResult;
  unableToConnect: boolean;
}

const HistoryBanner = ({
  isLastItem,
  chatOutageMessage,
  isLatestBanner,
  chatAvailability,
  unableToConnect,
}: BannerProps) => {
  if (isLastItem) {
    return (
      <StatusBanner
        chatAvailability={chatAvailability}
        unableToConnect={unableToConnect}
        chatOutageMessage={chatOutageMessage}
      />
    );
  } else if (isLatestBanner) {
    return <ChatBanner chatOutageMessage={chatOutageMessage} />;
  }

  return <ChatBanner />;
};

export default HistoryBanner;
